/* Method for getting and updating list data */

import axios from 'axios'
import errorParser from '@/shared/utils/ErrorParser'

export default {
    
    /**
     * Get data from the server
     * @param {string} cluster 
     * @param {string} uuid 
     */
    load(cluster, uuid) {
        return new Promise((resolve, reject) => {
            axios.get('/data/'+cluster+(uuid ? "/"+uuid : "")).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },   

    /**
     * Save data on the server
     * @param {String} cluster name
     * @param {String} uuid 
     * @param {object} data 
     */
    save(cluster, uuid, data) {
        return new Promise((resolve, reject) => {
            axios.put('/data/'+cluster+"/"+uuid, data).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },

    /**
     * Delete data
     * @param {string} cluster 
     * @param {string} uuid 
     */
    delete(cluster, uuid) {
        return new Promise((resolve, reject) => {
            axios.get('/delete/'+cluster+"/"+uuid).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },

    /**
     * Get list of data from the server
     * @param {string} cluster 
     * @param {string} status 
     */
    search(cluster, status) {
        return new Promise((resolve, reject) => {
            axios.get('/search/'+cluster+(status ? "/"+status : "")).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },

    /**
     * Check data and create summary
     * @param {string} uuid  
     */
    check(uuid) {
        return new Promise((resolve, reject) => {
            axios.get('/summary/pdf/'+uuid).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },

    /**
     * Execute button action on the server
     * @param {String} cluster name
     * @param {String} uuid 
     * @param {String} action 
     * @param {String} parameter
     */
    action(cluster, uuid, action, parameter) {
        return new Promise((resolve, reject) => {
            axios.put('/data/action/'+cluster+"/"+uuid, {action, parameter}).then(({data}) => {
                resolve(data);
            }).catch((error) => {
                reject(errorParser.parse(error));
            });
        });
    },
    
    
}
